// dashboard/frontend/src/components/CohortBacktestSection.js
import React, { useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getRuleBacktest } from '../services/api';
import BacktestLaunchForm from './BacktestLaunchForm';
import BacktestMatrixView from './BacktestMatrixView';

/* Section backtest cohorte d'une règle minée (#3a). Calquée sur BacktestSection :
   poll 4s tant que pending/running ; form (mode cohort) / spinner / matrice / erreur.
   L'entrée est dérivée du slot_tag de la règle (read-only). */

export default function CohortBacktestSection({ ruleId, slotTag }) {
  const qc = useQueryClient();
  const queryKey = ['rule-bt', ruleId];
  const [showForm, setShowForm] = useState(false);

  const { data, isLoading, isError, error } = useQuery({
    queryKey,
    queryFn: () => getRuleBacktest(ruleId),
    refetchInterval: (q) => {
      const s = q?.state?.data?.status;
      return (s === 'pending' || s === 'running') ? 4000 : false;
    },
  });

  const onLaunched = () => { qc.invalidateQueries({ queryKey }); setShowForm(false); };
  const form = (
    <BacktestLaunchForm mode="cohort" ruleId={ruleId} slotTag={slotTag} onLaunched={onLaunched} />
  );
  const card = (children) => (
    <div className="tdp-bt-card">
      <div className="tdp-bt-hd">⚙ Backtest cohorte (tokens matchant la règle × TP)</div>
      {children}
    </div>
  );

  if (isLoading) return card(<div className="tdp-empty">Chargement…</div>);
  if (isError) return card(<div className="tdp-empty">Erreur : {error?.message || 'inconnue'}</div>);

  const status = data?.status;
  if (status === 'pending' || status === 'running') {
    return card(<div className="tdp-empty">Backtest en cours… (statut : {status})</div>);
  }
  if (status === 'error') {
    return card(
      <div>
        <div className="tdp-empty" style={{ color: 'var(--red,#ff3b5c)' }}>
          Échec : {data?.error_msg || 'erreur inconnue'}
        </div>
        {form}
      </div>
    );
  }
  if (status === 'done') {
    if (showForm) {
      return card(
        <div>
          <BacktestLaunchForm
            mode="cohort"
            ruleId={ruleId}
            slotTag={slotTag}
            initialParams={data?.params}
            onLaunched={onLaunched}
          />
          <div className="tdp-ctrl" style={{ marginTop: 8 }}>
            <button className="tdp-btn" onClick={() => setShowForm(false)}>Annuler</button>
          </div>
        </div>
      );
    }
    return card(
      <div>
        <BacktestMatrixView result={data?.result} />
        <div className="tdp-ctrl" style={{ marginTop: 8 }}>
          <button className="tdp-btn on" onClick={() => setShowForm(true)}>Relancer</button>
        </div>
      </div>
    );
  }
  return card(form);  // 'none' ou inconnu → formulaire
}
